import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./components/login/login').then((m) => m.LoginComponent),
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./components/boot-error/boot-error').then((m) => m.BootErrorComponent),
  },
  {
    path: 'lobby',
    loadComponent: () =>
      import('./components/lobby/lobby').then((m) => m.LobbyComponent),
    canActivate: [authGuard],
  },
  {
    path: 'game/:gameId',
    loadComponent: () =>
      import('./components/game/game').then((m) => m.GameComponent),
    canActivate: [authGuard],
  },
  {
    path: 'screenshot',
    loadComponent: () =>
      import('./components/screenshot-game/screenshot-game').then((m) => m.ScreenshotGameComponent),
  },
  {
    path: 'profile/:username',
    loadComponent: () =>
      import('./components/profile/profile').then((m) => m.ProfileComponent),
    canActivate: [authGuard],
  },
  { path: '', redirectTo: 'lobby', pathMatch: 'full' },
  { path: '**', redirectTo: 'lobby' },
];
